

import {Component, EventEmitter, Input, OnInit, Output, ViewContainerRef} from '@angular/core';
import {Dialog} from "../../../../../../shared/dialog/dialog";
import {ApiAdminEmailTemplatesService} from "../../../../../../services/api/admin/admin-email-templates-api/admin-email-templates-api.service";

@Component({
  selector: 'app-admin-email-templates-create-edit-dialog',
  templateUrl: './admin-email-templates-create-edit-dialog.component.html'
})

export class AdminEmailTemplatesComponentDialog implements Dialog {

  @Input() data;
  @Output() remove = new EventEmitter<any>();

  isLoading = true;
  loadedId = null;

  showEditor = true;

  loadedData;

  constructor(
    private apiAdminEmailTemplatesService: ApiAdminEmailTemplatesService
  ) {}


  ngOnInit(): void {
    if(this.data !== null){
      this.loadedId = this.data;
      this.getData();
    } else {

      // Load Default Data
      this.loadedData = {
        Name: ''
      }

      this.isLoading = false;

    }
  }

  getData(){
    this.isLoading = true;
    this.apiAdminEmailTemplatesService.get(this.loadedId).then(response => {
      this.loadedData = response;
      // if(!this.loadedData.IsEmailEnabled && (this.loadedData.Name === 'TaskAssignedGroup' || this.loadedData.Name === 'TaskAssignedGroup')){
      //   this.loadedData.IsEmailEnabled = false;
      // } 
      this.isLoading = false;
    })
  }

  close(){
    this.remove.emit(null);
  }

  save(){
    if(this.loadedId){
      this.apiAdminEmailTemplatesService.update(this.loadedId, this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    } else {
      this.apiAdminEmailTemplatesService.create(this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    }

  }
}
